import React from 'react'
import LoadingIconFull from '~/Common-Objects/LoadingIcons/loadingIconFull'
import i18n from '~/i18n'

function mailchimpLoadingMessages(key) {
    const messages = i18n.t(key, { returnObjects: true })
    return Array.isArray(messages) ? messages : [messages]
}

/**
 * Shared Mailchimp import loading screen.
 * @param {{ variant?: 'connect' | 'discover' | 'lastImport' }} props
 */
export default function MailchimpDiscoverLoading({ variant = 'connect' }) {
    let statusKey = 'mailchimp2:loading.status'
    let hintKey = 'mailchimp2:loading.hint'
    if (variant === 'lastImport') {
        statusKey = 'mailchimp2:loading.lastImportStatus'
        hintKey = 'mailchimp2:loading.lastImportHint'
    } else if (variant === 'discover') {
        statusKey = 'mailchimp2:loading.discoverStatus'
        hintKey = 'mailchimp2:loading.discoverHint'
    }
    return <LoadingIconFull changingText={mailchimpLoadingMessages(statusKey)} bottomText={i18n.t(hintKey)} />
}
